module.exports = __webpack_public_path__ + "static/media/oz-mktg-logo-small.8ac20711.png";